import { render, staticRenderFns } from "./cusAuthAlarm.vue?vue&type=template&id=3c856764"
import script from "./cusAuthAlarm.vue?vue&type=script&lang=js"
export * from "./cusAuthAlarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports